<template>
    <v-form ref="signupForm" v-model="signupValid" lazy-validation @submit.prevent="validate">
        <div class="px-6">
            <v-text-field 
            ref="email" 
            v-model="email" 
            :rules="genericRules.emailRules" 
            label="E-mail" 
            required 
            color="grey" 
            outlined 
            dense 
            validate-on-blur 
            filled 
            hide-details="auto" 
            clearable 
            clear-icon="mdi-refresh" 
            @blur="resetField($refs.email)" 
            @input="checkEmail"
            :loading="emailChecking"
            :error-messages="emailErrorMessages"
            :success="emailSuccess">
                <template slot="append">
                    <v-icon class="success-icon" color="success">mdi-check</v-icon>
                    <v-icon class="error-icon" color="error">mdi-close</v-icon>
                </template>
            </v-text-field>
        </div>
        <div class="px-6 my-3">
            <v-text-field ref="name" 
            v-model="fullname" 
            :rules="genericRules.nameRules" 
            label="Full Name" 
            required 
            color="grey" 
            outlined 
            dense 
            validate-on-blur 
            filled 
            hide-details="auto" 
            clearable 
            clear-icon="mdi-refresh"
            @input="checkName"
            :success="fullnameSuccess"
            @blur="resetField($refs.name)">
                <template slot="append">
                    <v-icon class="success-icon" color="success">mdi-check</v-icon>
                    <v-icon class="error-icon" color="error">mdi-close</v-icon>
                </template>
            </v-text-field>
        </div>
        <div class="px-6 my-3">
            <v-text-field ref="username" 
            v-model="username" 
            :rules="genericRules.usernameRules" 
            label="Username" 
            required 
            color="grey" 
            outlined 
            dense 
            validate-on-blur 
            filled 
            hide-details="auto" 
            clearable 
            clear-icon="mdi-refresh" 
            :error-messages="userNameErrorMessages" 
            :success="userNameSuccess" 
            :loading="usernameChecking"
            @blur="resetField($refs.username)"
            @input="checkUsername">
                <template slot="append">
                    <v-icon class="success-icon" v-if="userNameSuccess" color="success">mdi-check</v-icon>
                    <v-icon class="error-icon" color="error">mdi-close</v-icon>
                </template>
            </v-text-field>
        </div>
        <div class="px-6 my-3">
            <v-text-field ref="password" 
            v-model="password" 
            :rules="genericRules.passwords" 
            label="Password" 
            type="password" 
            required 
            color="grey" 
            outlined 
            dense 
            validate-on-blur 
            filled 
            hide-details="auto" 
            clearable 
            clear-icon="mdi-refresh"
            :success="passwordSuccess"
            @input="checkPassword"
            @blur="resetField($refs.password)">
                <template slot="append">
                    <v-icon class="success-icon" color="success">mdi-check</v-icon>
                    <v-icon class="error-icon" color="error">mdi-close</v-icon>
                </template>
            </v-text-field>
        </div>
        <div class="px-6 my-3">
            <v-btn color="blue" @click="validate" block class="text-capitalize white--text" type="submit" :loading="userLoading" :disabled="userLoading">
                Signup
            </v-btn>
        </div>
    </v-form>
</template>
<script>
import {
    ALERT_EMAIL_IN_USE,
    ALERT_USERNAME_IN_USE
} from "@/base/config"
import ApiService from '@/base/api/api.service'
import formMixins from "@/mixins/mixin-forms"
export default {
    mixins: [formMixins],
    data: () => ({
        signupValid: false,
        fullname: '',
        fullnameSuccess: false,
        email: '',
        emailChecking: false,
        emailSuccess: false,
        emailErrorMessages: [],
        emailTimeout: null,
        username: '',
        usernameChecking: false,
        userNameErrorMessages: [],
        userNameSuccess: false,
        userNameTimeout: null,
        password: '',
        passwordSuccess: false
        
    }),

    methods: {
        validate() {
            if (this.$refs.signupForm.validate() && this.userNameSuccess && this.emailSuccess) {
                this.$emit('sendData', {
                    username: this.username,
                    email: this.email,
                    password: this.password,
                    name: this.fullname
                })
            }
        },

        checkEmail() {
            if(!this.$refs.email.validate()) {
                this.emailSuccess = false
                return
            }

            if(this.emailTimeout) clearTimeout(this.emailTimeout)
            this.emailTimeout = setTimeout(() => {
                this.emailChecking = true
                ApiService.checkEmail(this.$refs.email.value)
                .then(res => {
                    this.emailChecking = false
                    if(res) this.emailSuccess = true
                    this.emailErrorMessages = []
                })
                .catch(() => {
                    this.emailChecking = false
                    this.emailSuccess = false
                    this.emailErrorMessages.push(ALERT_EMAIL_IN_USE)
                })
            }, 500)
        },

        checkUsername() {
            if(!this.$refs.username.validate()) {
                this.userNameSuccess = false
                return
            }

            if(this.userNameTimeout) clearTimeout(this.userNameTimeout)
            this.userNameTimeout = setTimeout(() => {
                this.usernameChecking = true
                ApiService.checkUsername(this.$refs.username.value)
                .then(res => {
                    this.usernameChecking = false
                    if(res) this.userNameSuccess = true
                    this.userNameErrorMessages = []
                })
                .catch(() => {
                    this.usernameChecking = false
                    this.userNameSuccess = false
                    this.userNameErrorMessages.push(ALERT_USERNAME_IN_USE)
                })
            }, 500) 
        },

        checkName() {
            if(this.$refs.name !== undefined) {
                this.fullnameSuccess = this.$refs.name.validate()
            }
        },

        checkPassword() {
            if(this.$refs.password !== undefined) {
                this.passwordSuccess = this.$refs.password.validate()
            }
        }
    }
}
</script>